var _rect, _rect2, _path, _path2, _path3, _path4, _rect3, _rect4, _path5, _path6, _path7, _path8, _rect5, _rect6, _path9, _path0, _path1, _path10, _rect7, _rect8, _path11, _path12, _path13, _path14, _path15, _path16, _line, _rect9, _path17, _path18, _line2, _rect0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnc2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 153,
    viewBox: "0 0 153 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 84.8066,
    y: 30,
    width: 29.6629,
    height: 35.0562,
    rx: 3.59551,
    transform: "rotate(7.88143 84.8066 30)",
    fill: "#B1A084"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 82.8066,
    y: 27,
    width: 29.6629,
    height: 35.0562,
    rx: 3.59551,
    transform: "rotate(7.88143 82.8066 27)",
    fill: "#EFDC90"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.2852 33.9727L105.093 36.4378",
    stroke: "#BC9675",
    strokeWidth: 2.69663,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2988 41.0938L104.107 43.5589",
    stroke: "#BC9675",
    strokeWidth: 2.69663,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3281 55.3418L102.136 57.8069",
    stroke: "#BC9675",
    strokeWidth: 2.69663,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3125 48.2188L103.12 50.6839",
    stroke: "#BC9675",
    strokeWidth: 2.69663,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 83.1484,
    width: 29.6629,
    height: 35.0562,
    rx: 3.59551,
    transform: "rotate(-11.9596 37 83.1484)",
    fill: "#B1A084"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 81.1484,
    width: 29.6629,
    height: 35.0562,
    rx: 3.59551,
    transform: "rotate(-11.9596 34 81.1484)",
    fill: "#EFDC90"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5801 86.1855L58.1674 82.4602",
    stroke: "#BC9675",
    strokeWidth: 2.69663,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0703 93.2207L59.6576 89.4954",
    stroke: "#BC9675",
    strokeWidth: 2.69663,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0508 107.291L62.6381 103.566",
    stroke: "#BC9675",
    strokeWidth: 2.69663,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5605 100.256L61.1479 96.5305",
    stroke: "#BC9675",
    strokeWidth: 2.69663,
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 85.5898,
    y: 83.002,
    width: 29.6629,
    height: 35.0562,
    rx: 3.59551,
    transform: "rotate(10.8341 85.5898 83.002)",
    fill: "#B1A084"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 83.5898,
    y: 80.002,
    width: 29.6629,
    height: 35.0562,
    rx: 3.59551,
    transform: "rotate(10.8341 83.5898 80.002)",
    fill: "#EFDC90"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7051 87.1953L105.362 90.5745",
    stroke: "#BC9675",
    strokeWidth: 2.69663,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3535 94.2578L104.011 97.637",
    stroke: "#BC9675",
    strokeWidth: 2.69663,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6484 108.385L101.306 111.764",
    stroke: "#BC9675",
    strokeWidth: 2.69663,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M85 101.322L102.657 104.701",
    stroke: "#BC9675",
    strokeWidth: 2.69663,
    strokeLinecap: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 36.1191,
    width: 29.6629,
    height: 35.0562,
    rx: 3.59551,
    transform: "rotate(-13.8885 34 36.1191)",
    fill: "#B1A084"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 31.2266,
    y: 34.0742,
    width: 29.6629,
    height: 35.0562,
    rx: 3.59551,
    transform: "rotate(-13.8885 31.2266 34.0742)",
    fill: "#EFDC90"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9727 38.8887L55.4246 34.5735",
    stroke: "#BC9675",
    strokeWidth: 2.69663,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6992 45.8691L57.1512 41.5539",
    stroke: "#BC9675",
    strokeWidth: 2.69663,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1504 59.8301L60.6023 55.5149",
    stroke: "#BC9675",
    strokeWidth: 2.69663,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4238 52.8496L58.8758 48.5344",
    stroke: "#BC9675",
    strokeWidth: 2.69663,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5485 100.873L21.2621 93.3514L27.5166 91.0703L27.5485 100.873Z",
    fill: "#BC9675"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5715 101.044L25.4774 98.5384L27.5609 97.7786L27.5715 101.044Z",
    fill: "#EFCC90"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11.6545,
    y1: 57.5986,
    x2: 24.3696,
    y2: 92.2184,
    stroke: "#EFCC90",
    strokeWidth: 6.14682
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 8.24023,
    y: 57.2148,
    width: 6.14682,
    height: 6.14682,
    rx: 1.53671,
    transform: "rotate(-20.1671 8.24023 57.2148)",
    fill: "#BC9675"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M100.694 79.0618L107.332 71.8485L110.409 77.7523L100.694 79.0618Z",
    fill: "#BC9675"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M100.53 79.1065L102.742 76.7036L103.767 78.6703L100.53 79.1065Z",
    fill: "#EFCC90"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 141.53,
    y1: 57.6617,
    x2: 108.863,
    y2: 74.7811,
    stroke: "#EFCC90",
    strokeWidth: 6.14682
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 141.465,
    y: 54.2266,
    width: 6.14682,
    height: 6.14682,
    rx: 1.53671,
    transform: "rotate(62.3428 141.465 54.2266)",
    fill: "#BC9675"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnc2);
export default __webpack_public_path__ + "static/media/unc-2.50b21b3c187c2d02bed64061082728b9.svg";
export { ForwardRef as ReactComponent };